import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FuelTypography } from '@frete.com/fuel-react';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import FieldAddress from '../FieldAddress';
import FieldCity from '../FieldCity';
import FieldZipCode from '../FieldZipCode';
import { PlacePropsInterface } from './PlaceTypes';

function Place({ flow, hasMarginTop = false }: PlacePropsInterface) {
  let titleFlow = 'Origem';

  if (flow === 'delivery') {
    titleFlow = 'Destino';
  }

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        gap: 'km6',
        customMargin: `${hasMarginTop ? dsTokens.spacing.km4 : '0'} 0 0 0`,
      }}
    >
      <FuelTypography size="body-md" weight="bold">
        {titleFlow} da carga
      </FuelTypography>
      <FuelFlex defaultProps={{ gap: 'km4' }}>
        <FuelFlex
          defaultProps={{
            maxWidth: '189px',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: '100%',
          }}
        >
          <FieldZipCode flow={flow} />
        </FuelFlex>
        <FieldCity flow={flow} />
      </FuelFlex>
      <FieldAddress flow={flow} />
    </FuelFlex>
  );
}

export default Place;
